query group($id: ID!, $tz: String, $sortBy: StudentSort, $sortDirection: Direction, $page: Int) {
  group(id: $id) {
    id
    name
    studentCount
    order
    orderNumerator
    deletedAt(tz: $tz)
    deletingTeacher {
      id
      first
      last
    }
    icon {
      id
      name
      displayName
    }
    color {
      id
      name
      displayName
    }
    orderDenominator
    studentList(sortBy: $sortBy, sortDirection: $sortDirection, page: $page) {
      list {
        id
        first
        last
        positivity
        mostRecentCommunication
        communicationCount
        gradeLevel {
          id
          name
          order
        }
      }
      count
      remaining
      pageSize
    }
    teacher {
      id
      first
      last
      email
      isCurrent
    }
  }
}
